import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { MatchSummaryTablePlannerFragmentDoc } from './MatchSummaryTable.generated';
export type MatchSummaryPlannerFragment = { __typename?: 'Planner', name: string, id: string };

export type MatchSummaryMatchStatusFragment = { __typename?: 'MatchStatus', plannerId: string, inflowSource: string, numberOfMessages: number, createdAt: TimeString, hasTalked: boolean };

export const MatchSummaryPlannerFragmentDoc = gql`
    fragment MatchSummaryPlanner on Planner {
  ...MatchSummaryTablePlanner
  name
}
    ${MatchSummaryTablePlannerFragmentDoc}`;
export const MatchSummaryMatchStatusFragmentDoc = gql`
    fragment MatchSummaryMatchStatus on MatchStatus {
  plannerId
  inflowSource
  numberOfMessages
  createdAt
  hasTalked
}
    `;